import {
  AnalyticsHandsIcon,
  DashboardIcon,
  LeftRightIcon,
  ReportIcon,
  TokenManagementIcon,
  TransactionIcon,
  UsersIcon,
  WalletIcon,
} from '../assets/Icon';
import CogIcon from '../assets/Icon/CogIcon';

// import Gift from '../assets/gift.png'

export enum URole {
  COMPANY_ADMIN = 'ADMIN',
  USER = 'USER',
  FINANCE_TEAM = 'FINANCE TEAM',
  ORGANIZATION = 'ORGANIZATION',
  TOKEN_MANAGER = 'TOKEN MANAGER',
  VIEWER = 'VIEWER',
  VENDOR = 'VENDOR',
}

export const USER_MENU_ITEMS = [
  { icon: WalletIcon, text: 'Wallet', path: '/wallet' },
  { icon: TransactionIcon, text: 'Transactions', path: '/transactions' },
];

export const VENDOR_MENU_ITEMS = [
  { icon: WalletIcon, text: 'Wallet', path: '/wallet' },
  { icon: TransactionIcon, text: 'Transactions', path: '/transactions' },
  { icon: AnalyticsHandsIcon, text: 'Cash Out', path: '/cash-out' },
];
export const USER = [
  '/dashboard',
  '/wallet',
  '/transactions',
  '/cash-out',
  '/profile',
];

export const COMPANY_MENU_ITEMS = [
  {
    icon: TokenManagementIcon,
    text: 'Token Management',
    path: '/token-management',
  },
  { icon: UsersIcon, text: 'User Management', path: '/user-management' },
  { icon: LeftRightIcon, text: 'Settlement', path: '/settlement' },
  { icon: UsersIcon, text: 'Requested Token', path: '/requested-token' },
  { icon: UsersIcon, text: ' Gift Cards', path: '/gift-cards' },
  { icon: UsersIcon, text: 'Vendor', path: '/vendor' },
  { icon: TransactionIcon, text: 'Transactions', path: '/transactions-all' },
  { icon: CogIcon, text: 'Settings', path: '/settings' },
];

export const SUB_ADMIN_MENU_ITEMS = [
  { icon: WalletIcon, text: 'Wallet', path: '/wallet' },
  { icon: UsersIcon, text: 'User Management', path: '/user-management' },
  { icon: UsersIcon, text: ' Gift Cards', path: '/gift-cards' },
  { icon: UsersIcon, text: 'Vendor', path: '/vendor' },
  { icon: TransactionIcon, text: 'Transactions', path: '/transactions-all' },
];

export const ADMIN = [
  '/dashboard',
  '/token-management',
  '/token-management/mint-token',
  '/token-management/transfer-token',
  '/user-management',
  '/user-management/details',
  '/rbac',
  '/settlement',
  '/settings',
  '/profile',
  '/requested-token',
  '/transactions',
  '/transactions-all',
];

export function getMenuItemsByRole(role: URole) {
  if (!role) {
    return [];
  }
  switch (role) {
    case URole.COMPANY_ADMIN:
      return COMPANY_MENU_ITEMS;
    case URole.ORGANIZATION:
      return SUB_ADMIN_MENU_ITEMS;
    case URole.USER:
      return USER_MENU_ITEMS;
    case URole.VENDOR:
      return VENDOR_MENU_ITEMS;
    default:
      return USER_MENU_ITEMS;
  }
}
